"use client";

import type { PropsWithChildren } from "react";
import { useColoredSection } from "~/components/bloks/ColoredSectionBlok/useColoredSection";
import type { ColoredSectionStoryblok } from "~/generated/sb/blok-types";

export const ClientColorTrigger = ({
	blok,
	children,
}: PropsWithChildren<{
	blok: ColoredSectionStoryblok;
}>) => {
	const { ref } = useColoredSection(blok.color);

	return (
		<div className="background__change__trigger" ref={ref}>
			{children}
		</div>
	);
};
